// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"bd824358","999":"dc571658"}[chunkId] + ".chunk.js";
};